import React from 'react';
import { Table, Empty } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { AttendanceRow } from '../../../services/p9310Api';

interface ResultTableProps {
  data: AttendanceRow[];
  loading: boolean;
  queried: boolean;
  noData: boolean;
}

const columns: ColumnsType<AttendanceRow> = [
  {
    title: '員工代號',
    dataIndex: 'f910_01',
    key: 'f910_01',
    width: 100,
    fixed: 'left' as const,
  },
  {
    title: '員工姓名',
    dataIndex: 'emp_name',
    key: 'emp_name',
    width: 100,
  },
  {
    title: '出勤日期',
    dataIndex: 'f910_02',
    key: 'f910_02',
    width: 110,
    render: (v: string) => v?.substring(0, 10) || '',
  },
  {
    title: '狀態碼',
    dataIndex: 'f910_11',
    key: 'f910_11',
    width: 70,
    align: 'center' as const,
  },
  {
    title: '類別碼',
    dataIndex: 'f910_12',
    key: 'f910_12',
    width: 70,
    align: 'center' as const,
  },
  {
    title: '打卡時間',
    dataIndex: 'f910_13',
    key: 'f910_13',
    width: 90,
    render: (v: string) => {
      if (!v || !v.trim()) return '';
      const s = v.trim();
      if (s.length >= 4) {
        return `${s.substring(0, 2)}:${s.substring(2, 4)}`;
      }
      return s;
    },
  },
  {
    title: '班別',
    dataIndex: 'f910_15',
    key: 'f910_15',
    width: 60,
    align: 'center' as const,
  },
  {
    title: '正常工時',
    dataIndex: 'f910_27',
    key: 'f910_27',
    width: 90,
    align: 'right' as const,
  },
  {
    title: '加班時數',
    dataIndex: 'f910_28',
    key: 'f910_28',
    width: 90,
    align: 'right' as const,
  },
  {
    title: '遲到(分)',
    dataIndex: 'f910_29',
    key: 'f910_29',
    width: 90,
    align: 'right' as const,
  },
  {
    title: '早退(分)',
    dataIndex: 'f910_30',
    key: 'f910_30',
    width: 90,
    align: 'right' as const,
  },
  {
    title: '職等',
    dataIndex: 'f901_37',
    key: 'f901_37',
    width: 60,
    align: 'center' as const,
  },
  {
    title: '備註',
    dataIndex: 'f910_14',
    key: 'f910_14',
    ellipsis: true,
  },
];

const ResultTable: React.FC<ResultTableProps> = React.memo(({ data, loading, queried, noData }) => {
  if (queried && noData) {
    return <Empty description="查無此資料" style={{ marginTop: 40 }} />;
  }

  if (!queried) {
    return null;
  }

  return (
    <Table<AttendanceRow>
      columns={columns}
      dataSource={data}
      rowKey={(r, i) => `${r.f910_01}-${r.f910_02}-${i}`}
      loading={loading}
      size="small"
      pagination={{
        pageSize: 50,
        showSizeChanger: true,
        pageSizeOptions: ['20', '50', '100', '200'],
        showTotal: (total) => `共 ${total} 筆`,
      }}
      scroll={{ x: 1200 }}
    />
  );
});

ResultTable.displayName = 'ResultTable';

export default ResultTable;
